import { render, staticRenderFns } from "./libro.vue?vue&type=template&id=0f80fdab&scoped=true&"
import script from "./libro.vue?vue&type=script&lang=js&"
export * from "./libro.vue?vue&type=script&lang=js&"
import style0 from "./libro.vue?vue&type=style&index=0&id=0f80fdab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f80fdab",
  null
  
)

export default component.exports